import { type DeliveryClass, DELIVERY_CLASS } from '@hooks-api/types/dataModel/shipping'
import style from '../style/components/cart-item.module.scss'
import { Freeze } from './icon'

interface Props {
  thumbnail: string
  deliveryClass: DeliveryClass
  productName: string
}
export const VariationImg = (props: Props) => {
  const { thumbnail, deliveryClass, productName } = props
  return (
    <div className={style.img}>
      <img src={thumbnail} alt={productName} />
      {deliveryClass === DELIVERY_CLASS.FROZEN && <Freeze />}
    </div>
  )
}
